import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import TimelineRoundedIcon from '@material-ui/icons/TimelineRounded';
import strings from 'strings';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { ROLEPLAY_DIFFICULTY_OPTIONS } from '../constants';
import { FullWidthFormControlLabel } from '../styles';

export const COPIES = strings.ai.generators.roleplay;

export const RoleplayDifficultyFields = ({ disabled = false, formFieldsMap }) => {
  const { control, errors } = useFormContext();

  return (
    <Box my={3}>
      <Box alignItems="center" display="flex" flexDirection="row" gridGap={8}>
        <TimelineRoundedIcon />
        <Typography variant="subtitle1">{COPIES.form.sections.difficulty.title}</Typography>
      </Box>

      <FormControl component="fieldset" error={!!errors[formFieldsMap.Difficulty.key]}>
        <Controller
          as={
            <RadioGroup aria-label="difficulty">
              {ROLEPLAY_DIFFICULTY_OPTIONS.map(item => (
                <FullWidthFormControlLabel
                  control={<Radio disabled={disabled} color="primary" />}
                  key={item.id}
                  label={
                    <Box display="flex" flexDirection="column">
                      <Typography variant="body1">{item.label}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        {item.description}
                      </Typography>
                    </Box>
                  }
                  value={item.id}
                />
              ))}
            </RadioGroup>
          }
          control={control}
          defaultValue={ROLEPLAY_DIFFICULTY_OPTIONS[0].id}
          name={formFieldsMap.Difficulty.key}
          onChange={([event]) => event.target.value}
          onChangeName="onChange"
          rules={REQUIRED_VALIDATION}
          valueName="value"
        />

        <FormHelperText>{errors[formFieldsMap.Difficulty.key]?.message}</FormHelperText>
      </FormControl>
    </Box>
  );
};
